//Modules
import React, { useEffect, useState } from "react"
//Styles
import { StyledContainer } from "../../Elements"
//Live Contentful
import client from "../../config/contentful"
//Components
import Album from "./Album"

const Gallery = () => {
  const [albums, setAlbums] = useState([])

  useEffect(() => {
    client
      .getEntries({
        content_type: "album",
      })
      .then(res => {
        setAlbums(res.items)
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  return (
    <StyledContainer>
      <h1>Gallery</h1>
      {albums.map((album, i) => {
        return <Album album={album} key={i} />
      })}
    </StyledContainer>
  )
}

export default Gallery
